import React, { PropTypes } from 'react';
import { browserHistory, Link } from 'react-router';
import Helmet from 'react-helmet';

import LoginForm from '../forms/LoginForm';
import AboutBlock from '../components/AboutBlock';

import bookShelf from '../assets/images/photographs/3-books-shelf.png';

const LoginPage = ({ actions }) => (
    <div>
        <Helmet title="Login" />
        <div className="login-wrapper index-1">
            <div className="inner">
                <div className="container">
                    <div className="row">
                        <div className="col-md-7 title-area">
                            <h1>Enterprise education resources</h1>
                            <h2>For primary school class reading<br /> and PSHE lessons.</h2>
                            <img src={bookShelf} alt="clever tykes books" className="img-responsive" />
                        </div>
                        <div className="col-md-5" >
                            <div className="login-block">
                                <h2>New users</h2>
                                <div className="register-btn-container">
                                    <button onClick={() => browserHistory.push('/register')}>Register new account</button>
                                </div>
                            </div>
                            <br />
                            <div className="login-block">
                                <h2>Existing users - Log in</h2>
                                <LoginForm handleSubmit={actions.loginRequest} />
                                <div className="note">
                                    <Link className="selected" to="/forget-password">Forgotten your password?</Link>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <AboutBlock />
    </div>
);

LoginPage.propTypes = {
    actions: PropTypes.object
};

export default LoginPage;



/** WEBPACK FOOTER **
 ** ./src/pages/LoginPage.js
 **/